const ErrorScreen = () => {
    return <div>404</div>;
};

export default ErrorScreen;
